<template>
  <div class="mrgt md-mrgt+ lg-mrgt++">
    <div class="section section--light pdgv md-pdgv+ mrgb md-mrgb+ lg-mrgb++">
      <div class="container">
        <Usage />
      </div>
    </div>

    <div class="container">
      <ul role="presentation" class="questions-list list">
        <template v-if="['cooking', 'industrial'].includes(usageId)">
          <li>
            <div class="container container--tight container--small">
              <CustomerPortalLink />
            </div>
          </li>
        </template>
        <template v-if="usageId">
          <li v-for="(question, i) in localQuestions" :key="i">
            <component
              :is="question.component"
              v-bind="question.context || {}"
            />
          </li>
        </template>
        <li v-if="estimationCompleted" role="presentation">
          <EstimationSummary @next="next" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Usage from '@/components/simulation/questions/Usage.vue';
import EstimationSummary from '@/components/simulation/EstimationSummary.vue';
import CustomerPortalLink from '@/components/simulation/CustomerPortalLink.vue';
import { useRouter } from 'vue-router';
import { useSimulation } from '@/composables/useSimulation';

const { questions, usageId, simulation, estimationCompleted } = useSimulation();

const localQuestions = computed(() => {
  const result = [];

  if (questions.value) {
    const questionTree = generateQuestionsTree(questions.value);

    for (let i = 0; i < questionTree.length; i++) {
      const current = questionTree[i];
      const previous = questionTree[i - 1];
      if (!previous || previous.done()) {
        result.push(current);
      } else {
        break;
      }
    }
  }
  return result;
});

const generateQuestionsTree = (recursiveQuestions) => {
  let result = [];

  recursiveQuestions.forEach((question) => {
    if (typeof question === 'function') {
      result.push(question(simulation));
    } else {
      result.push(question.question(simulation));

      const path = question.paths.find((path) => {
        return path.matches(simulation);
      });

      if (path) {
        result = result.concat(generateQuestionsTree(path.questions));
      }
    }
  });
  return result;
};

const router = useRouter();

const next = () => {
  /**
   * Recursively build the questions list based on the config
   * Automatically displays the next question once the previous is complete
   */
  router.push({ name: 'products' });
};
</script>

<style lang="scss" scoped>
.questions-list {
  li + li {
    margin-top: $spacing-unit-large;

    @include media('md') {
      margin-top: 50px;
    }
  }
}
</style>
